import React from 'react';
import { ApiUrlData, WebUrlData } from '@base-configs';
import { InitialValuePageProviderEntity } from '@base-entities';
import { PageProvider } from '@base-providers';
import { PageController } from '@base-components';

import { RegionEntity } from '../../domain/entities';

import PageIndex from '../pages';

export function RegionFactory() {
  const InitialValue: InitialValuePageProviderEntity<RegionEntity> = {
    moduleKey: 'data-region-pages', // make sure this key unique each module
    webUrl: WebUrlData.data_region,
    apiUrl: ApiUrlData.region,
  };

  return (
    <PageProvider initialValue={InitialValue}>
      <PageController PageIndex={PageIndex} />
    </PageProvider>
  );
}
